module.exports = __webpack_public_path__ + "media/images/hero_images/about-1200-c4563857fcc64c4a25ab6d13c97bb5af.jpg";